import { useLazyQuery, useMutation } from "@apollo/client";
import { useRecoilState } from "recoil";

import {
  FOLLOWERS_QUERY,
  FOLLOW_UNFOLLOW_MUTATION,
  MY_FOLLOWERS_QUERY,
} from "../../../GraphQL/followers";
import { AllstarUser } from "../../../State";

export const useFollowers = () => {
  const [allstarUser, setAllstarUser] = useRecoilState(AllstarUser);

  const [mutateFollowers] = useMutation(FOLLOW_UNFOLLOW_MUTATION, {
    refetchQueries: [MY_FOLLOWERS_QUERY, FOLLOWERS_QUERY],
  });

  const [requestUserFollowers] = useLazyQuery(FOLLOWERS_QUERY, {
    fetchPolicy: "cache-and-network",
  });

  const fetchFollowers = async (userId: string) => {
    try {
      const { data: followers } = await requestUserFollowers({
        variables: { userId, profiles: true, clips: false },
      });

      const followingData = followers?.myFollowing?.profiles || [];

      if (allstarUser.loggedIn && userId === allstarUser.user?._id) {
        setAllstarUser({
          ...allstarUser,
          followers: followingData,
        });
      }

      return followingData;
    } catch (error) {
      return [];
    }
  };

  const followUser = async (userId: string, follow: boolean) => {
    try {
      await mutateFollowers({
        variables: { userId, follow },
      });
      return true;
    } catch (error) {
      return false;
    }
  };

  return {
    fetchFollowers,
    followUser,
    mutateFollowers,
  };
};
